import { invalidateCache } from 'api/urql/helpers/mutation';

export const blockWorker = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('paginatedTeams')(
    results,
    args,
    cache,
    info
  );
};
